[
  {"iso2": "IR", "dial": "98", "en": "Iran", "fa": "ایران", "ar": "إيران"},
  {"iso2": "AF", "dial": "93", "en": "Afghanistan", "fa": "افغانستان", "ar": "أفغانستان"},
  {"iso2": "DZ", "dial": "213", "en": "Algeria", "fa": "الجزایر", "ar": "الجزائر"},
  {"iso2": "AM", "dial": "374", "en": "Armenia", "fa": "ارمنستان", "ar": "أرمينيا"},
  {"iso2": "AU", "dial": "61", "en": "Australia", "fa": "استرالیا", "ar": "أستراليا"},
  {"iso2": "AT", "dial": "43", "en": "Austria", "fa": "اتریش", "ar": "النمسا"},
  {"iso2": "AZ", "dial": "994", "en": "Azerbaijan", "fa": "آذربایجان", "ar": "أذربيجان"},
  {"iso2": "BH", "dial": "973", "en": "Bahrain", "fa": "بحرین", "ar": "البحرين"},
  {"iso2": "BE", "dial": "32", "en": "Belgium", "fa": "بلژیک", "ar": "بلجيكا"},
  {"iso2": "BR", "dial": "55", "en": "Brazil", "fa": "برزیل", "ar": "البرازيل"},
  {"iso2": "CA", "dial": "1", "en": "Canada", "fa": "کانادا", "ar": "كندا"},
  {"iso2": "CN", "dial": "86", "en": "China", "fa": "چین", "ar": "الصين"},
  {"iso2": "CY", "dial": "357", "en": "Cyprus", "fa": "قبرس", "ar": "قبرص"},
  {"iso2": "DK", "dial": "45", "en": "Denmark", "fa": "دانمارک", "ar": "الدنمارك"},
  {"iso2": "EG", "dial": "20", "en": "Egypt", "fa": "مصر", "ar": "مصر"},
  {"iso2": "FI", "dial": "358", "en": "Finland", "fa": "فنلاند", "ar": "فنلندا"},
  {"iso2": "FR", "dial": "33", "en": "France", "fa": "فرانسه", "ar": "فرنسا"},
  {"iso2": "GE", "dial": "995", "en": "Georgia", "fa": "گرجستان", "ar": "جورجيا"},
  {"iso2": "DE", "dial": "49", "en": "Germany", "fa": "آلمان", "ar": "ألمانيا"},
  {"iso2": "GR", "dial": "30", "en": "Greece", "fa": "یونان", "ar": "اليونان"},
  {"iso2": "HU", "dial": "36", "en": "Hungary", "fa": "مجارستان", "ar": "المجر"},
  {"iso2": "IN", "dial": "91", "en": "India", "fa": "هند", "ar": "الهند"},
  {"iso2": "ID", "dial": "62", "en": "Indonesia", "fa": "اندونزی", "ar": "إندونيسيا"},
  {"iso2": "IQ", "dial": "964", "en": "Iraq", "fa": "عراق", "ar": "العراق"},
  {"iso2": "IT", "dial": "39", "en": "Italy", "fa": "ایتالیا", "ar": "إيطاليا"},
  {"iso2": "JP", "dial": "81", "en": "Japan", "fa": "ژاپن", "ar": "اليابان"},
  {"iso2": "JO", "dial": "962", "en": "Jordan", "fa": "اردن", "ar": "الأردن"},
  {"iso2": "KZ", "dial": "7", "en": "Kazakhstan", "fa": "قزاقستان", "ar": "كازاخستان"},
  {"iso2": "KW", "dial": "965", "en": "Kuwait", "fa": "کویت", "ar": "الكويت"},
  {"iso2": "LB", "dial": "961", "en": "Lebanon", "fa": "لبنان", "ar": "لبنان"},
  {"iso2": "LY", "dial": "218", "en": "Libya", "fa": "لیبی", "ar": "ليبيا"},
  {"iso2": "MY", "dial": "60", "en": "Malaysia", "fa": "مالزی", "ar": "ماليزيا"},
  {"iso2": "MR", "dial": "222", "en": "Mauritania", "fa": "موریتانی", "ar": "موريتانيا"},
  {"iso2": "MA", "dial": "212", "en": "Morocco", "fa": "مراکش", "ar": "المغرب"},
  {"iso2": "NL", "dial": "31", "en": "Netherlands", "fa": "هلند", "ar": "هولندا"},
  {"iso2": "NZ", "dial": "64", "en": "New Zealand", "fa": "نیوزیلند", "ar": "نيوزيلندا"},
  {"iso2": "NO", "dial": "47", "en": "Norway", "fa": "نروژ", "ar": "النرويج"},
  {"iso2": "OM", "dial": "968", "en": "Oman", "fa": "عمان", "ar": "عُمان"},
  {"iso2": "PK", "dial": "92", "en": "Pakistan", "fa": "پاکستان", "ar": "باكستان"},
  {"iso2": "PS", "dial": "970", "en": "Palestine", "fa": "فلسطین", "ar": "فلسطين"},
  {"iso2": "PL", "dial": "48", "en": "Poland", "fa": "لهستان", "ar": "بولندا"},
  {"iso2": "QA", "dial": "974", "en": "Qatar", "fa": "قطر", "ar": "قطر"},
  {"iso2": "RU", "dial": "7", "en": "Russia", "fa": "روسیه", "ar": "روسيا"},
  {"iso2": "SA", "dial": "966", "en": "Saudi Arabia", "fa": "عربستان سعودی", "ar": "السعودية"},
  {"iso2": "SG", "dial": "65", "en": "Singapore", "fa": "سنگاپور", "ar": "سنغافورة"},
  {"iso2": "ZA", "dial": "27", "en": "South Africa", "fa": "آفریقای جنوبی", "ar": "جنوب أفريقيا"},
  {"iso2": "ES", "dial": "34", "en": "Spain", "fa": "اسپانیا", "ar": "إسبانيا"},
  {"iso2": "SD", "dial": "249", "en": "Sudan", "fa": "سودان", "ar": "السودان"},
  {"iso2": "SE", "dial": "46", "en": "Sweden", "fa": "سوئد", "ar": "السويد"},
  {"iso2": "CH", "dial": "41", "en": "Switzerland", "fa": "سوئیس", "ar": "سويسرا"},
  {"iso2": "SY", "dial": "963", "en": "Syria", "fa": "سوریه", "ar": "سوريا"},
  {"iso2": "TJ", "dial": "992", "en": "Tajikistan", "fa": "تاجیکستان", "ar": "طاجيكستان"},
  {"iso2": "TH", "dial": "66", "en": "Thailand", "fa": "تایلند", "ar": "تايلاند"},
  {"iso2": "TN", "dial": "216", "en": "Tunisia", "fa": "تونس", "ar": "تونس"},
  {"iso2": "TR", "dial": "90", "en": "Türkiye", "fa": "ترکیه", "ar": "تركيا"},
  {"iso2": "TM", "dial": "993", "en": "Turkmenistan", "fa": "ترکمنستان", "ar": "تركمانستان"},
  {"iso2": "UA", "dial": "380", "en": "Ukraine", "fa": "اوکراین", "ar": "أوكرانيا"},
  {"iso2": "AE", "dial": "971", "en": "United Arab Emirates", "fa": "امارات متحدهٔ عربی", "ar": "الإمارات العربية المتحدة"},
  {"iso2": "GB", "dial": "44", "en": "United Kingdom", "fa": "بریتانیا", "ar": "المملكة المتحدة"},
  {"iso2": "US", "dial": "1", "en": "United States", "fa": "ایالات متحده", "ar": "الولايات المتحدة"},
  {"iso2": "UZ", "dial": "998", "en": "Uzbekistan", "fa": "ازبکستان", "ar": "أوزبكستان"},
  {"iso2": "YE", "dial": "967", "en": "Yemen", "fa": "یمن", "ar": "اليمن"}
]
